import React from "react";
import { useGetSchoolBranchesOptions } from "../../hooks/branchHooks/branch.hooks";
import Dropdown from "../Dropdown/dropdown";
import { DropdownOptions } from "../dropdownOptions";
import { DateField } from "../input/DateField";
import { useGetClassesOptions } from "../../hooks/classHooks/class.hooks";
import { getSelectedOptionFromValue } from "../../Helper/options.helper";
import { ResultTypeDropdown } from "./ResultType.Dropdown";

interface Props {
  schoolBranchId: number | null;
  onBranchSelect: (branchId: number) => unknown;
  selectedClass: number | null;
  onClassSelect: (classId: number) => unknown;
  publishDate: string;
  setPublishDate: (publishDate: string) => unknown;
  resultType: string | null;
  onResultTypeSelect: (resultType: string) => unknown;
}

export const ResultForm = ({
  schoolBranchId,
  onBranchSelect,
  selectedClass,
  onClassSelect,
  publishDate,
  setPublishDate,
  onResultTypeSelect,
  resultType,
}: Props) => {
  const { isLoading: isSchoolBranchOptLoading, data: SCHOOL_BRANCH_OPTIONS } =
    useGetSchoolBranchesOptions();

  const { isLoading: isClassOptionsLoading, data: CLASSES_OPTIONS } =
    useGetClassesOptions();

  if (isSchoolBranchOptLoading || isClassOptionsLoading) return <div />;

  return (
    <div className="flex flex-col">
      <Dropdown
        label="Select school branch"
        options={SCHOOL_BRANCH_OPTIONS || []}
        selectedOption={getSelectedOptionFromValue(
          SCHOOL_BRANCH_OPTIONS || [],
          schoolBranchId,
        )}
        setSelectedOption={(selectedOption: DropdownOptions) => {
          onBranchSelect(selectedOption.value as number);
        }}
      />

      <Dropdown
        label="Class"
        options={CLASSES_OPTIONS || []}
        selectedOption={getSelectedOptionFromValue(
          CLASSES_OPTIONS || [],
          selectedClass,
        )}
        setSelectedOption={(option) => {
          onClassSelect(option.value as number);
        }}
      />

      <ResultTypeDropdown
        onResultTypeSelect={(selectedResultType) => {
          onResultTypeSelect(selectedResultType.value);
        }}
        selectedResultType={resultType}
      />

      <DateField
        date={publishDate}
        setDate={setPublishDate}
        label="Result publish date"
      />
    </div>
  );
};
